import * as React from "react";
import { Button, ModalConfirm } from "@nordcloud/gnui";
import { PagerDutyBusinessService } from "~/models/pagerDutyBusinessService";

type PagerDutyBusinessServiceDeleteProps = {
  businessService: PagerDutyBusinessService;
  removeCallback: (id: string) => Promise<void>;
  disabled?: boolean;
};

function PagerDutyBusinessServiceDelete({
  businessService,
  removeCallback,
  disabled,
}: PagerDutyBusinessServiceDeleteProps) {
  const [isOpen, setIsOpen] = React.useState(false);

  const removePDBusinessService = React.useCallback(async () => {
    try {
      await removeCallback(businessService.id);
    } finally {
      setIsOpen(false);
    }
  }, [businessService, removeCallback]);

  return (
    <>
      <Button
        icon="trash"
        size="sm"
        severity="low"
        disabled={disabled}
        onClick={() => setIsOpen(true)}
      >
        Remove
      </Button>

      <ModalConfirm
        onClose={() => setIsOpen(false)}
        isOpen={isOpen}
        confirm={removePDBusinessService}
        actionLabel="Remove"
        contentLabel="Remove PagerDuty Business Service"
      >
        Are you sure you want to remove PagerDuty business service{" "}
        <strong>{businessService.name}</strong>?
      </ModalConfirm>
    </>
  );
}

export { PagerDutyBusinessServiceDelete };
